var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":!_vm.bottom,"bottom":_vm.bottom},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","large":"","loading":_vm.loading,"disabled":_vm.disabled},on:{"click":_vm.download}},on),[_c('v-icon',[_vm._v("get_app")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltip)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }